module.exports = __webpack_public_path__ + "img/icon_text_add.3b64bc59.png";